export const menuWidth = '18.75rem'
export const monamiPhone = '650-267-2474'
